import { createSlice } from '@reduxjs/toolkit';
import { initialState } from '../../../../data/entitlement/contracts/relatedContracts/initialState.relatedcontracts.data';
import { fetchRelatedContracts as fetchRelatedContractsAPI } from '../../../../apis/contractsAPI';
import { ACTIONS_CONTRACTS } from '../../../../constants/actionCreator';
import { createAsyncThunkWrapper } from '../../../../services/common/asyncThunkWrapper';

export const fetchRelatedContractsData = createAsyncThunkWrapper(
  ACTIONS_CONTRACTS.FETCH_RELATED_CONTRACTS,
  fetchRelatedContractsAPI
);

const RelatedContractsSlice = createSlice({
  name: 'relatedContracts',
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(fetchRelatedContractsData.pending, (state) => {
        state.relatedContractsData = [];
        state.relatedContractsLoading = true;
      })
      .addCase(fetchRelatedContractsData.fulfilled, (state, action) => {
        let rContracts = [];
        if(action?.payload?.contracts?.length > 0) {
            action?.payload?.contracts?.map((item, index) => {
                item?.relatedContracts?.map((rItem, rIndex) => {
                    rContracts.push(rItem);
                });
            });

            state.relatedContractsData = rContracts;
            state.relatedContractsCount = action?.payload?.totalRecords || 0;
        }
        else {
            state.relatedContractsData = [];
            state.relatedContractsCount = 0;
        }

        state.relatedContractsLoading = false;
      })
      .addCase(fetchRelatedContractsData.rejected, (state) => {
        state.relatedContractsData = [];
        state.relatedContractsLoading = false;
      });
  },
});

export const {} = RelatedContractsSlice.actions;

export default RelatedContractsSlice.reducer;
